"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const progress_bar_1 = require("../actions/progress-bar");
const ProgressBar = () => {
    const { progressBar: { currentStep, steps } } = (0, react_redux_1.useSelector)(s => s);
    const stepper = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (stepper.current != null) {
            stepper.current.stepItems = steps;
        }
    }, [steps]);
    (0, react_1.useEffect)(() => {
        if (stepper.current != null && currentStep < steps.length) {
            stepper.current.stepItems = steps;
            (0, progress_bar_1.initializeProgressBar)(steps);
        }
    }, [currentStep, steps]);
    if (steps.length < 2)
        return null;
    return react_1.default.createElement("s-stepper", { ref: stepper });
};
exports.default = ProgressBar;
